import actions from 'state/constants';

const signingUpForProductUpdatesReducer = (state, action) => ({
  ...state,
  signingUpForProductUpdates: {
    ...state.signingUpForProductUpdates,
    [action.payload.variantSku]: false,
  },
  signedUpForProductUpdates: {
    ...state.signedUpForProductUpdates,
    [action.payload.variantSku]: true,
  },
});

const signingUpForNewsletterReducer = state => ({
  ...state,
  signingUpForNewsletter: false,
  signedUpForNewsletter: true,
});

// Figure out how to update state based on incoming action type
export const reducer = (state = {}, action) => {
  switch (action.type) {
    case actions.SIGN_UP_PRODUCT_UPDATES_REQUEST:
      return signingUpForProductUpdatesReducer(state, action);

    case actions.SIGN_UP_NEWSLETTER_REQUEST:
      return signingUpForNewsletterReducer(state, action);

    default:
      return state;
  }
};

export default reducer;
